import { render, staticRenderFns } from "./PresentToAll.vue?vue&type=template&id=0121ba36"
import script from "./PresentToAll.vue?vue&type=script&lang=js"
export * from "./PresentToAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports